class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      var zipcode = localStorage.getItem('zipcode');
       if (zipcode !== null && !isNaN(zipcode)) {
        $('.shippingCharge').addClass('loading');
      }
      this.closest("cart-notification").updateQuantity(this.dataset.index, 0);
      //this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.cartItemConatiner = document.getElementById(
      "cart-notification-product"
    );

    this.emptyCartItem = document.getElementById("min-cart-items");
    this.emptyAbtMSBX = document.getElementById("main-shipping--bx");
    this.cartItemMessageShow = document.querySelector(".empty__cart__item");
    this.emptyCartButtonDisable = document.getElementById(
      "empty__cart__button"
    );

    this.cartAddSuccess = document.querySelector(".item__success_message ");
    this.cartEmptyHead = document.querySelector(".item__empty_message");
    this.cartAddSuccessNew = document.querySelector(".item__success_message-new ");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    this.querySelector(
      'button[type="button"].cart-notification__close'
    ).addEventListener("click", this.close.bind(this));

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    if (!event.target.closest("select")) {
       if (!event.target.dataset.index || !event.target.value) {
        return;
      }
      var zipcode = localStorage.getItem('zipcode');
       if (zipcode !== null && !isNaN(zipcode)) {
        $('.shippingCharge').addClass('loading');
      }
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    const subtotalElement = document.querySelector("#cart-notification-subtotal");
    if (subtotalElement) {
      const rawSubtotal = subtotalElement.textContent;
      const cleanSubtotal = rawSubtotal.replace(/[\$,\.]/g, "");
      const subtotalValue = parseInt(cleanSubtotal, 10);
      const b2bcustomer = document.querySelector(".b2b-customer");
      if (!b2bcustomer) {
        updateProgressBar(subtotalValue);
      }
    }
    const b2bcustomer = document.querySelector(".b2b-customer");
    if (!b2bcustomer) {
      if (localStorage.getItem('countryname') && $("#cart-notification-count").text().trim() !== "0") {
          var zipcode = localStorage.getItem('zipcode');
          var statename = localStorage.getItem('statename');
          calculateRates(zipcode, statename);
          $('#zipVal').html('' + zipcode + '<span id="editCode"><svg height=14px viewBox="0 -1 401.52289 401"width=14px xmlns=http://www.w3.org/2000/svg><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"></path></svg></span>');
          $('.shipping_wrapper').hide();
      }
    }
    document.body.addEventListener("click", this.onBodyClick);
        
  }

  close() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClick);
    

    //removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id]
      );
    });

    // Toggle Class
    this.emptyCartItem.classList.toggle(
      "no-js-inline",
      parsedState.item_count === 0
    );

    if (parsedState.item_count === 0) {
      this.emptyCartItem.classList.add("no-js-inline");
      this.emptyAbtMSBX.classList.add("no-js-inline");
      this.emptyCartButtonDisable.classList.add("no-js-inline");
      this.cartItemMessageShow.classList.remove("no-js-inline");
      this.cartAddSuccess.classList.add("no-js-inline");
      this.cartAddSuccessNew.classList.add("no-js-inline");
      this.cartEmptyHead.classList.remove("no-js-inline");
    } else {
      this.emptyCartItem.classList.remove("no-js-inline");
      this.emptyAbtMSBX.classList.remove("no-js-inline");
      this.emptyCartButtonDisable.classList.remove("no-js-inline");
      this.cartItemMessageShow.classList.add("no-js-inline");
      this.cartAddSuccess.classList.remove("no-js-inline");
      this.cartAddSuccessNew.classList.remove("no-js-inline");
      this.cartEmptyHead.classList.add("no-js-inline");
    }

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
      },
      {
        id: "cart-notification-subtotal",
      },
      {
        id: "cart-notification-count",
      },
      {
        id: "cart-notification-discount",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });
    if (name !== undefined) {
        if (!line || !quantity) {
            return;
        }
    }
    document
      .querySelector(".cart_action_drawer_overlay")
      .classList.add("active");
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }

        this.renderContents(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {
        // const errors =
        //   document.getElementById("cart-errors") ||
        //   document.getElementById("CartDrawer-CartErrors");
        // errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        // this.disableLoading(line);
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
      $('.shippingCharge').removeClass('loading');
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();

    this.cartButton = this.querySelector("a");

    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.querySelector("body").classList.add("added__overlay");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
    
    const b2bcustomer = document.querySelector(".b2b-customer");
      if (!b2bcustomer) {
        if (!FGSECOMAPP.offers.some(offer => offer.giftsAvailable > 0))
        {
          const progressBarMessage = document.getElementById("congratsMsg");
          const unlockedFreeGift = document.getElementById("unlocked-free-gift");
          unlockedFreeGift.style.display = "none";
          progressBarMessage.innerHTML = `Congrats, you've succesfully added the free gift.`;  
        }
    }
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    document.querySelector("body").classList.remove("added__overlay");

    document.body.removeEventListener("click", this.onBodyClassRemove);
    
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);

function updateProgressBar(totalPrice) {
  const progressBarMessage = document.getElementById("progress-bar-message");
  const milestones = [10000, 17500, 25000, 35000, 45000, 52000, 85000];

  if (totalPrice < milestones[0]) {
    const remainingAmount = milestones[0] - totalPrice;
    progressBarMessage.innerHTML = `You are away <span class="progress-pricing">$${(remainingAmount / 100).toFixed(2)}</span> from unlocking the free gift.`;
  } else if (totalPrice >= milestones[milestones.length - 1]) {
    // If the totalPrice is above or equal to the last milestone
    progressBarMessage.innerHTML = `Congrats, you've unlocked the free gift. 
      <a id="unlocked-free-gift" href="" style="color: #fbb040;font-weight: 600;">Click here</a> to add the gift.`;
    const giftLink = document.getElementById("unlocked-free-gift");
    if (giftLink && !sessionStorage.getItem('giftUnlocked')) {
    setTimeout(function() {
       giftLink.click();
      sessionStorage.setItem('giftUnlocked', 'true');
      }, 1000);
    }
  } else {
    for (let i = 0; i < milestones.length - 1; i++) {
      if (totalPrice >= milestones[i] && totalPrice < milestones[i + 1]) {
        const remainingAmount = milestones[i + 1] - totalPrice;
        progressBarMessage.innerHTML = `Congrats, you've unlocked the free gift. 
          <a id="unlocked-free-gift" href="" style="color: #fbb040;font-weight: 600;">Click here</a> to add the gift. 
          You are <span class="progress-pricing">$${(remainingAmount / 100).toFixed(2)}</span> away from the next tier.`;
        const giftLink = document.getElementById("unlocked-free-gift");
        if (giftLink && !sessionStorage.getItem('giftUnlocked')) {
        setTimeout(function() {
           giftLink.click();
          sessionStorage.setItem('giftUnlocked', 'true');
          }, 1000);
        }
        break;
      }
    }
  }
}

var acc = document.getElementsByClassName("cart-promotion-title");
var cartHeight = document.querySelector('cart-notification');
var finalHeight = cartHeight.offsetHeight + 'px';
var i;
for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.display === "block") {
      panel.style.display = "none";
    } else {
      panel.style.display = "block";
      //panel.style.height = finalHeight;
    }
  });
}

// Swiper: Slider
new Swiper('.cart_product_slider', {
    loop: false,
    nextButton: '.swiper-button-next',
    prevButton: '.swiper-button-prev',
    slidesPerView: 'auto',
    paginationClickable: true,
    spaceBetween: 20,
});


$(document).ready(function() {
    if (localStorage.getItem("countryname") === null) {
        $.getScript('https://js.maxmind.com/js/apis/geoip2/v2.1/geoip2.js', function() {
            var onSuccess = function(location){
                var state_code = JSON.stringify(location.subdivisions[0]['iso_code']);
                var statecode = state_code.replace(/['"]+/g, '');

                var state_name = JSON.stringify(location.subdivisions[0]['names']['en']);
                var statename = state_name.replace(/['"]+/g, '');

                var postal_code = JSON.stringify(location.postal['code'], undefined, 4);
                var zipcode = postal_code.replace(/['"]+/g, '');

                var country = JSON.stringify(location.country['names']['en'], undefined, 4);
                var country_name = country.replace(/['"]+/g, '');

                var city = JSON.stringify(location.city['names']['en'], undefined, 4);
                var city_name = city.replace(/['"]+/g, '');

                localStorage.setItem('countryname', country_name);  
                localStorage.setItem('cityname', city_name);
                localStorage.setItem('statecode', statecode);
                localStorage.setItem('zipcode', zipcode);
                localStorage.setItem('statename', statename);
                var state_name = statename;
                // Uncomment and modify the following code as needed
                // if (state_code == 'NY' || state_code == 'NJ' || state_code == 'PA' || state_code == 'IL' || state_code == 'MI') {
                //     $('.for-ontario-city').css({"display": "block"});
                // } else {
                //     $('.for-ontario-city').css({"display": "none"});
                // }
            };
            var onError = function(error) {
                // alert(
                //     "Error:\n\n"
                //     + JSON.stringify(error, undefined, 4)
                // );
              $('.shippingCharge').removeClass('loading');
            };
            geoip2.city(onSuccess, onError);
        });
    }
    if (localStorage.getItem('countryname') && $("#cart-notification-count").text().trim() !== "0") {
        var zipcode = localStorage.getItem('zipcode');
        var statename = localStorage.getItem('statename');
           if (zipcode !== null && !isNaN(zipcode)) {
            $('.shippingCharge').addClass('loading');
          }
        calculateRates(zipcode, statename);
        $('#zipVal').html('' + zipcode + '<span id="editCode"><svg height=14px viewBox="0 -1 401.52289 401"width=14px xmlns=http://www.w3.org/2000/svg><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"></path></svg></span>');
        $('.shipping_wrapper').hide();
    }
    $('body #zipVal').on('click', function(e) {
      e.preventDefault();
      $('.shipping_wrapper').show();
    });
});
function checkPincode(pincode) {
  var pin_val = pincode;
  var errorElement = $('.shipping_wrapper').siblings('.error');
  if (!isNaN(pin_val)) {
        $.ajax({
        type: "GET",
        beforeSend: function(request) {
          request.setRequestHeader("x-key", "9a611d2cf072201acc6442753627e9bff2df2845");
        },
        url: "//zip.getziptastic.com/v3/US/"+pin_val,
        success: function(data) {
          localStorage.setItem('countryname', data[0]['country']);  
          localStorage.setItem('cityname', data[0]['city']);
          localStorage.setItem('statecode', data[0]['state_short']);
          localStorage.setItem('statename', data[0]['state']);
          localStorage.setItem('zipcode', data[0]['postal_code']);
          calculateRates(pin_val, data[0]['state']);
        },
        error: function(xhr, status, error) {
          $('.shippingCharge').removeClass('loading');
          var errorElement = $('.shipping_wrapper').siblings('.error');   
           $('.shippingCharge').text('');
           errorElement.text('Please enter the correct zip code');
        }
      });
      }
}
function calculateRates(pin_val, countryState) { 
  if (!isNaN(pin_val) && countryState.trim() !== '') {
     var shippingCountryZip = pin_val;
     var shippingCountry = 'United States';
     var countryState = countryState;
      $.ajax({
        url: `/cart/shipping_rates.json`,
        type: 'GET',
        data: {
          'shipping_address[zip]': shippingCountryZip,
          'shipping_address[country]': shippingCountry,
          'shipping_address[province]': countryState
        },
        dataType: 'json',
        success: function(data) {
          //console.log('shipping data', data);
            var errorElement = $('.shipping_wrapper').siblings('.error');   
            if (data.shipping_rates && data.shipping_rates.length > 0) {
              if (data.shipping_rates[0].price == '0.00') {
                $('.shippingCharge').text('Free');
                errorElement.text('');
              } else {
                errorElement.text('');
                $('.shippingCharge').text(shopCurrencySymbol + data.shipping_rates[0].price);
              }
            } else {
              $('.shippingCharge').text('');
              errorElement.text('We found 0 shipping rate(s) for your address');
            }
          $('.shippingCharge').removeClass('loading');
        },
        error: function(xhr, status, error) {
          if (xhr.status === 422) {
            var response = JSON.parse(xhr.responseText);
            var errorMessage = '';
            if (response.zip && response.zip.length > 0) {
                errorMessage = response.zip[0];
            } else if (response.province && response.province.length > 0) {
                errorMessage = response.province[0];
            }
            if (errorMessage) {
                $('.shippingCharge').removeClass('loading');
                var errorElement = $('.shipping_wrapper').siblings('.error');   
                 $('.shippingCharge').text('');
                 errorElement.text(errorMessage);
            }
          }else{
          console.error('Error:', error);
          }
        }
      });    
  }else{
    $('.shippingCharge').removeClass('loading');
    var errorElement = $('.shipping_wrapper').siblings('.error');   
     $('.shippingCharge').text('');
     errorElement.text('Please enter the correct zip code');
  }
}
jQuery.loadScript = function (url, callback) 
{
  jQuery.ajax({
      url: url,
      dataType: 'script',
      success: callback,
      async: true
  });
}
function loadShippingCode() {
    var country_name = localStorage.getItem('countryname'); 
    var city_name = localStorage.getItem('cityname');
    var zip_code = localStorage.getItem('zipcode');
    var state_name = localStorage.getItem('statename');
    var state_code = localStorage.getItem('statecode');  
  // console.log(state_name, "state_name");
  //   console.log(zip_code, "zip_code");
      // alert("testing-"+country_name);
    if (state_name !== null && zip_code !== null) {
      $('#zipVal').html('' + zip_code + '<span id="editCode"><svg height=14px viewBox="0 -1 401.52289 401"width=14px xmlns=http://www.w3.org/2000/svg><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"></path></svg></span>');
      $('.shipping_wrapper').hide();
      $("#ShippingZip").val(zip_code);
      calculateRates(zip_code, state_name);
      // $('#zipVal').on('click', function(e) {
      //   e.preventDefault();
      //   $('.shipping_wrapper').show();
      //   //changeZipcodeClick();   
      // });
    }
    // else {      
    //    changeZipcodeClick();      
    // }
}
$('body [data-action="calculate"]').on('click', function() {
    var pincode = $("#ShippingZip").val();    
    var errorElement = $('.shipping_wrapper').siblings('.error');
    $('.shippingCharge').addClass('loading');
     if (!/^\d{5}$/.test(pincode)) {     
       $('.shippingCharge').text('');
       errorElement.text('Please enter the correct zip code');
       $('.shippingCharge').removeClass('loading');
      return;
    }
    else {
      errorElement.text('');
      $('#zipVal').html('' + pincode + '<span id="editCode"><svg height=14px viewBox="0 -1 401.52289 401"width=14px xmlns=http://www.w3.org/2000/svg><path d="m370.589844 250.972656c-5.523438 0-10 4.476563-10 10v88.789063c-.019532 16.5625-13.4375 29.984375-30 30h-280.589844c-16.5625-.015625-29.980469-13.4375-30-30v-260.589844c.019531-16.558594 13.4375-29.980469 30-30h88.789062c5.523438 0 10-4.476563 10-10 0-5.519531-4.476562-10-10-10h-88.789062c-27.601562.03125-49.96875 22.398437-50 50v260.59375c.03125 27.601563 22.398438 49.96875 50 50h280.589844c27.601562-.03125 49.96875-22.398437 50-50v-88.792969c0-5.523437-4.476563-10-10-10zm0 0"></path><path d="m376.628906 13.441406c-17.574218-17.574218-46.066406-17.574218-63.640625 0l-178.40625 178.40625c-1.222656 1.222656-2.105469 2.738282-2.566406 4.402344l-23.460937 84.699219c-.964844 3.472656.015624 7.191406 2.5625 9.742187 2.550781 2.546875 6.269531 3.527344 9.742187 2.566406l84.699219-23.464843c1.664062-.460938 3.179687-1.34375 4.402344-2.566407l178.402343-178.410156c17.546875-17.585937 17.546875-46.054687 0-63.640625zm-220.257812 184.90625 146.011718-146.015625 47.089844 47.089844-146.015625 146.015625zm-9.40625 18.875 37.621094 37.625-52.039063 14.417969zm227.257812-142.546875-10.605468 10.605469-47.09375-47.09375 10.609374-10.605469c9.761719-9.761719 25.589844-9.761719 35.351563 0l11.738281 11.734375c9.746094 9.773438 9.746094 25.589844 0 35.359375zm0 0"></path></svg></span>');
      checkPincode(pincode);
      $('.shipping_wrapper').hide();
    }   
  });
